"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setProxy = setProxy;
exports.enable = enable;
exports.getComputedStyleForNode = getComputedStyleForNode;
exports.getInlineStylesForNode = getInlineStylesForNode;
exports.getMatchedStylesForNode = getMatchedStylesForNode;
exports.getBackgroundColors = getBackgroundColors;
exports.getStyleSheetText = getStyleSheetText;
exports.setStyleTexts = setStyleTexts;
var nodeManager_1 = require("../lib/nodeManager");
var stylesheet = __importStar(require("../lib/stylesheet"));
var map_1 = __importDefault(require("licia/map"));
var last_1 = __importDefault(require("licia/last"));
var each_1 = __importDefault(require("licia/each"));
var trim_1 = __importDefault(require("licia/trim"));
var selector_1 = __importDefault(require("licia/selector"));
var startWith_1 = __importDefault(require("licia/startWith"));
var concat_1 = __importDefault(require("licia/concat"));
var escapeRegExp_1 = __importDefault(require("licia/escapeRegExp"));
var connector_1 = __importDefault(require("../lib/connector"));
var mutationObserver_1 = __importDefault(require("../lib/mutationObserver"));
var constants_1 = require("../lib/constants");
var proxy = '';
function setProxy(params) {
    proxy = params.proxy;
}
function enable() {
    (0, each_1.default)(stylesheet.getStyleSheets(), function (styleSheet) {
        if (styleSheet.styleSheetId) {
            connector_1.default.trigger('CSS.styleSheetAdded', {
                header: {
                    frameId: constants_1.MAIN_FRAME_ID,
                    isInline: false,
                    styleSheetId: styleSheet.styleSheetId,
                    sourceURL: styleSheet.href || '',
                    startColumn: 0,
                    startLine: 0,
                    endColumn: 0,
                    endLine: 0,
                },
            });
        }
    });
}
function getComputedStyleForNode(params) {
    var node = (0, nodeManager_1.getNode)(params.nodeId);
    var computedStyle = stylesheet.formatStyle(window.getComputedStyle(node));
    return {
        computedStyle: toCssProperties(computedStyle),
    };
}
function getInlineStylesForNode(params) {
    var nodeId = params.nodeId;
    var node = (0, nodeManager_1.getNode)(nodeId);
    var style = node.style;
    var inlineStyle = {
        shorthandEntries: [],
        cssProperties: [],
    };
    if (style) {
        var styleSheetId = stylesheet.getOrCreateInlineStyleSheetId(nodeId);
        inlineStyle.styleSheetId = styleSheetId;
        var cssText_1 = node.getAttribute('style') || '';
        inlineStyle.cssText = cssText_1;
        inlineStyle.range = {
            startLine: 0,
            startColumn: 0,
            endLine: getLineCount(cssText_1) - 1,
            endColumn: (0, last_1.default)(cssText_1.split('\n')).length,
        };
        var cssPropertiesWithRange = toCssProperties(parseCssText(cssText_1));
        cssPropertiesWithRange = (0, map_1.default)(cssPropertiesWithRange, function (_a) {
            var name = _a.name, value = _a.value;
            var _b = getInlineStyleRange(name, value, cssText_1), text = _b.text, range = _b.range;
            var ret = {
                name: name,
                value: value,
                text: text,
                range: range,
            };
            if ((0, startWith_1.default)(text, '/*')) {
                ret.disabled = true;
            }
            else {
                ret.disabled = false;
                ret.implicit = false;
                ret.parsedOk = style[name] !== '';
            }
            return ret;
        });
        var parsedStyle_1 = stylesheet.formatStyle(style);
        (0, each_1.default)(cssPropertiesWithRange, function (_a) {
            var name = _a.name;
            return delete parsedStyle_1[name];
        });
        var cssPropertiesWithoutRange = toCssProperties(parsedStyle_1);
        inlineStyle.shorthandEntries = getShorthandEntries(style);
        inlineStyle.cssProperties = (0, concat_1.default)(cssPropertiesWithRange, cssPropertiesWithoutRange);
    }
    return {
        inlineStyle: inlineStyle,
    };
}
function getMatchedStylesForNode(params) {
    var node = (0, nodeManager_1.getNode)(params.nodeId);
    var matchedCSSRules = stylesheet.getMatchedCssRules(node);
    return __assign({ matchedCSSRules: (0, map_1.default)(matchedCSSRules, function (matchedCSSRule) {
            return formatMatchedCssRule(node, matchedCSSRule);
        }) }, getInlineStylesForNode(params));
}
function getBackgroundColors(params) {
    var node = (0, nodeManager_1.getNode)(params.nodeId);
    var computedStyle = stylesheet.formatStyle(window.getComputedStyle(node));
    return {
        backgroundColors: [computedStyle['background-color']],
        computedFontSize: computedStyle['font-size'],
        computedFontWeight: computedStyle['font-weight'],
    };
}
function getStyleSheetText(params) {
    return __awaiter(this, void 0, void 0, function () {
        var styleSheetId, nodeId, text, node;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    styleSheetId = params.styleSheetId;
                    nodeId = stylesheet.getInlineStyleNodeId(styleSheetId);
                    text = '';
                    if (!nodeId) return [3, 1];
                    node = (0, nodeManager_1.getNode)(nodeId);
                    text = node.getAttribute('style') || '';
                    return [3, 3];
                case 1: return [4, stylesheet.getStyleSheetText(styleSheetId, proxy)];
                case 2:
                    text = _a.sent();
                    _a.label = 3;
                case 3: return [2, {
                        text: text,
                    }];
            }
        });
    });
}
function setStyleTexts(params) {
    var edits = params.edits;
    var styles = (0, map_1.default)(edits, function (edit) {
        var styleSheetId = edit.styleSheetId, text = edit.text, range = edit.range;
        var nodeId = stylesheet.getInlineStyleNodeId(styleSheetId);
        if (nodeId) {
            var node = (0, nodeManager_1.getNode)(nodeId);
            var cssText = node.getAttribute('style') || '';
            var _a = getPosFromRange(range, cssText), start = _a.start, end = _a.end;
            cssText = cssText.slice(0, start) + text + cssText.slice(end);
            node.setAttribute('style', cssText);
            return getInlineStylesForNode({ nodeId: nodeId }).inlineStyle;
        }
        return { styleSheetId: styleSheetId };
    });
    return {
        styles: styles,
    };
}
function splitSelector(selectorText) {
    var groups = selector_1.default.parse(selectorText);
    return (0, map_1.default)(groups, function (group) { return (0, trim_1.default)(selector_1.default.stringify([group])); });
}
function formatMatchedCssRule(node, matchedCssRule) {
    var selectorText = matchedCssRule.selectorText;
    var selectors = splitSelector(selectorText);
    var shorthandEntries = getShorthandEntries(matchedCssRule.style);
    var style = stylesheet.formatStyle(matchedCssRule.style);
    var rule = {
        styleSheetId: matchedCssRule.styleSheetId,
        selectorList: {
            selectors: (0, map_1.default)(selectors, function (selector) { return ({ text: selector }); }),
            text: selectorText,
        },
        style: {
            cssProperties: toCssProperties(style),
            shorthandEntries: shorthandEntries,
        },
    };
    var matchingSelectors = [];
    (0, each_1.default)(selectors, function (selector, idx) {
        if (stylesheet.matchesSelector(node, selector)) {
            matchingSelectors.push(idx);
        }
    });
    return {
        matchingSelectors: matchingSelectors,
        rule: rule,
    };
}
stylesheet.onStyleSheetAdded(function (styleSheet) {
    connector_1.default.trigger('CSS.styleSheetAdded', {
        header: {
            styleSheetId: styleSheet.styleSheetId,
            sourceURL: '',
            startColumn: 0,
            startLine: 0,
            endColumn: 0,
            endLine: 0,
        },
    });
});
function toCssProperties(style) {
    var cssProperties = [];
    (0, each_1.default)(style, function (value, name) {
        cssProperties.push({
            name: name,
            value: value,
        });
    });
    return cssProperties;
}
function getLineCount(str) {
    return str.split('\n').length;
}
var shortHandNames = ['background', 'font', 'border', 'margin', 'padding'];
function getShorthandEntries(style) {
    var ret = [];
    (0, each_1.default)(shortHandNames, function (name) {
        var value = style[name];
        if (value) {
            ret.push({
                name: name,
                value: value,
            });
        }
    });
    return ret;
}
function parseCssText(cssText) {
    cssText = cssText.replace(/\/\*/g, '').replace(/\*\//g, '');
    var properties = cssText.split(';');
    var ret = {};
    (0, each_1.default)(properties, function (property) {
        property = (0, trim_1.default)(property);
        if (!property)
            return;
        var colonPos = property.indexOf(':');
        if (colonPos) {
            var name_1 = (0, trim_1.default)(property.slice(0, colonPos));
            var value = (0, trim_1.default)(property.slice(colonPos + 1));
            ret[name_1] = value;
        }
    });
    return ret;
}
function getInlineStyleRange(name, value, cssText) {
    var lines = cssText.split('\n');
    var startLine = 0;
    var endLine = 0;
    var startColumn = 0;
    var endColumn = 0;
    var text = '';
    var reg = new RegExp("(\\/\\*)?\\s*".concat((0, escapeRegExp_1.default)(name), ":\\s*").concat((0, escapeRegExp_1.default)(value), ";?\\s*(\\*\\/)?"));
    for (var i = 0, len = lines.length; i < len; i++) {
        var line = lines[i];
        var match = line.match(reg);
        if (match) {
            text = match[0];
            startLine = i;
            startColumn = match.index || 0;
            endLine = i;
            endColumn = startColumn + text.length;
            break;
        }
    }
    return {
        range: {
            startLine: startLine,
            endLine: endLine,
            startColumn: startColumn,
            endColumn: endColumn,
        },
        text: text,
    };
}
function getPosFromRange(range, cssText) {
    var startLine = range.startLine, startColumn = range.startColumn, endLine = range.endLine, endColumn = range.endColumn;
    var start = 0;
    var end = 0;
    var lines = cssText.split('\n');
    for (var i = 0; i <= endLine; i++) {
        var line = lines[i] + 1;
        var len = line.length;
        if (i < startLine) {
            start += len;
        }
        else if (i === startLine) {
            start += startColumn;
        }
        if (i < endLine) {
            end += len;
        }
        else if (i === endLine) {
            end += endColumn;
        }
    }
    return {
        start: start,
        end: end,
    };
}
mutationObserver_1.default.on('attributes', function (target, name) {
    var nodeId = (0, nodeManager_1.getNodeId)(target);
    if (!nodeId)
        return;
    if (name !== 'style')
        return;
    var styleSheetId = stylesheet.getInlineStyleSheetId(nodeId);
    if (styleSheetId) {
        connector_1.default.trigger('CSS.styleSheetChanged', {
            styleSheetId: styleSheetId,
        });
    }
});
